import React from "react";
import { Typography, Grid2 as Grid } from "@mui/material";
import Course from "../models/Course";

interface CourseDetailsProps {
  course: Course;
}

const CourseDetails: React.FC<CourseDetailsProps> = ({ course }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h6">{course.name}</Typography>
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Typography>Type: {course.type}</Typography>
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Typography>Point of Contact: {course.pointOfContact}</Typography>
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Typography>
          Start Date: {new Date(course.startDate).toLocaleDateString()}
        </Typography>
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Typography>
          End Date: {new Date(course.endDate).toLocaleDateString()}
        </Typography>
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Typography>Location: {course.location}</Typography>
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Typography>Max Students: {course.maxStudents}</Typography>
      </Grid>
    </Grid>
  );
};

export default CourseDetails;
